import type { FC } from "react";
import { Container, Row } from "@viagogo/core/ui";
import { Content } from "src/shared/components/content";
import { useWriteUrl } from "src/shared/utils/url-builder";
import {
  ContentDivider,
  LearnMoreLink,
  StyledTextBodyRow,
  TextWrapper,
} from "src/website-apps/responsive/stubhub-about-us/components/stubhub/styled-components";
import { StyledTitle } from "src/website-apps/shared/components/branding/styled-components";

export const Partners: FC = () => {
  const partnersUrl = useWriteUrl("/partners");

  return (
    <>
      <ContentDivider />
      <TextWrapper>
        <Container>
          <Row>
            <StyledTitle>
              <Content id="cid$#1906772#" />
            </StyledTitle>
          </Row>
          <StyledTextBodyRow>
            <Content id="cid$#1937482#" />
          </StyledTextBodyRow>
          <StyledTextBodyRow>
            <LearnMoreLink url={partnersUrl} newTab>
              <Content id="cid$#1907088#" raw />
            </LearnMoreLink>
          </StyledTextBodyRow>
        </Container>
      </TextWrapper>
    </>
  );
};
